






































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.AgentDto = new proxy.AgentDto();
    ctypes: any[] = [];
    apitypes: any[] = [];
    get prox() {
        return new proxy.AgentServiceProxy();
    }
    yueRecordPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.AgentBalanceLogPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '类型',
                key: 'balanceTypeName'
            },
            {
                title: "变动前",
                key: "balance",
            },
            {
                title: "变动",
                key: "money",
            },
            {
                title: "变动后",
                key: "afterBalance",
            },
            {
                title: "变动说明",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    yuetzPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.AgentBalanceAdjustOrderPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '调整单号',
                key: 'orderNo'
            },
            {
                title: "调整金额",
                key: "money",
            },
            {
                title: "调整原因",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };

    pagesizeChange(data, page, t) {
        data.pageSize = page;
        switch (t) {
            case 1:
                this.yueRecordPageNumberChange(data.pageNumber);
                break;
            case 2:
                this.yuetzPageNumberChange(data.pageNumber);
                break;
        }
    }
    yueRecordPageNumberChange(page: number) {
        this.yueRecordPage.isTableLoading = true;
        this.yueRecordPage.input.maxResultCount = this.yueRecordPage.pageSize;
        this.yueRecordPage.input.skipCount = (page - 1) * this.yueRecordPage.pageSize;
        this.yueRecordPage.input.agentId = this.id || 0;
        new proxy.AgentBalanceLogServiceProxy().queryModelList(this.yueRecordPage.input).then((x) => {
            this.yueRecordPage.isTableLoading = false;
            this.yueRecordPage.dataList = x.items;
            this.yueRecordPage.totalItems = x.totalCount;
            this.yueRecordPage.totalPages = Math.ceil(
                x.totalCount / this.yueRecordPage.pageSize
            );
        });
    }
    yuetzPageNumberChange(page: number) {
        this.yuetzPage.isTableLoading = true;
        this.yuetzPage.input.maxResultCount = this.yuetzPage.pageSize;
        this.yuetzPage.input.skipCount = (page - 1) * this.yuetzPage.pageSize;
        this.yuetzPage.input.agentId = this.id || 0;
        new proxy.AgentBalanceAdjustOrderServiceProxy().queryModelList(this.yuetzPage.input).then((x) => {
            this.yuetzPage.isTableLoading = false;
            this.yuetzPage.dataList = x.items;
            this.yuetzPage.totalItems = x.totalCount;
            this.yuetzPage.totalPages = Math.ceil(
                x.totalCount / this.yuetzPage.pageSize
            );
        });
    }
    save() {
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.createOrUpdate(this.model).then(() => {
                    (this.$refs.roleForm as any).resetFields();
                    this.$Notice.success({ title: '保存成功' });
                    this.$emit('save-success');
                    this.$emit('input', false);
                });
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {

            this.prox.queryModel(this.id).then(x => {
                this.model = x;
                this.yueRecordPageNumberChange(1);
                this.yuetzPageNumberChange(1);
            });
        }
    }

    roleRule = {
        suppName: [
            {
                required: true,
                message: this.L('FieldIsRequired'),
                trigger: 'blur'
            }
        ]
    };
}
